export enum HistoryFeedTheme {
  WHITE = 'WHITE',
  GREY = 'GREY',
}
